enum EntityEmailSyncStatus {
  QUEUED = "queued",
  COMPLETED = "completed",
  RUNNING = "running",
  ERRORED = "errored",
}

export default EntityEmailSyncStatus;
